import { FleetAggregation } from "./fleet-aggregation.model";

export class FleetDataModel {

  constructor(jsonObject: any = null) {

    if (jsonObject == null) {
      return;
    }

    this.numberOfActiveCars = jsonObject.numberOfActiveCars;
    this.numberOfOrderedCars = jsonObject.numberOfOrderedCars;
    this.numberOfExtendedContracts = jsonObject.numberOfExtendedContracts;
    this.numberOfContractsRunningOut = jsonObject.numberOfContractsRunningOut;
    this.numberOfSuborderDraftsFromFleetCC = jsonObject.numberOfSuborderDraftsFromFleetCC;

    this.numberOfActiveCarsByMake = jsonObject.numberOfActiveCarsByMake?.map((element: any) => new FleetAggregation(element)) ?? [];
    this.numberOfActiveCarsByYearDetailed = jsonObject.numberOfActiveCarsByYearDetailed?.map((element: any) => new FleetAggregation(element)) ?? [];
    this.numberOfActiveCarsByYearAggregated = jsonObject.numberOfActiveCarsByYearAggregated?.map((element: any) => new FleetAggregation(element)) ?? [];
    this.numberOfActiveCarsByFuel = jsonObject.numberOfActiveCarsByFuel?.map((element: any) => new FleetAggregation(element)) ?? [];    
  }

  numberOfActiveCars: number;
  numberOfOrderedCars: number;
  numberOfSuborderDraftsFromFleetCC: number;
  numberOfExtendedContracts: number;
  numberOfContractsRunningOut: number;

  numberOfActiveCarsByMake: FleetAggregation[];
  numberOfActiveCarsByYearDetailed: FleetAggregation[];
  numberOfActiveCarsByYearAggregated: FleetAggregation[];
  numberOfActiveCarsByFuel: FleetAggregation[];
}
